var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar-line_1_",
    "data-name": "calendar-line (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23143",
    "data-name": "Path 23143",
    d: "M0,0H15V15H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23144",
    "data-name": "Path 23144",
    d: "M10.25,2.1h2.2a.55.55,0,0,1,.55.55v8.8a.55.55,0,0,1-.55.55H2.55A.55.55,0,0,1,2,11.45V2.65a.55.55,0,0,1,.55-.55h2.2V1h1.1V2.1h3.3V1h1.1ZM9.15,3.2H5.85V4.3H4.75V3.2H3.1V5.4h8.8V3.2H10.25V4.3H9.15ZM11.9,6.5H3.1v4.4h8.8Z",
    fill: "#3f8fc6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSmall);
export default __webpack_public_path__ + "static/media/calender-small.1d9f91911fcb79d7cab0e14d598a75d5.svg";
export { ForwardRef as ReactComponent };